import React from 'react'
import ItemLists from '../../components/itemdetailscomponents/ItemLists';

function ItemDetailsList({renderPageContent}) {
    return (
        <>
             <ItemLists renderPageContent={renderPageContent}/>
        </>
    )
}

export default ItemDetailsList;
